import { gsap, ScrollTrigger, ScrollToPlugin } from 'gsap/all';
import { CountUp } from 'countup.js';
import { SplitText } from '../../vendor/gsap/SplitText';
import { ScrollSmoother } from '../../vendor/gsap/ScrollSmoother';
import smoov from '../../util/smooth-scroll';
import '../../util/form-label';

gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother, ScrollToPlugin);
smoov();
// Animated number countup function for the stats block
function runNum(elem) {
    if ($(elem).hasClass('activated')) {
        return false;
    }
    const dataNum = $(elem).attr('data-num');
    const thisId = $(elem).attr('id');
    const statNum = new CountUp(`${thisId}`, dataNum, {
        decimal: ',',
    });

    if (!statNum.error) {
        $(elem).addClass('activated');
        statNum.start();
    } else {
        console.error(statNum.error);
    }
    return false;
}

function mobileParallax() {
    gsap.to('.masthead-parallax-image .img-parent', {
        yPercent: -10,
        ease: 'none',
        scrollTrigger: {
            trigger: '.masthead-parallax-image',
            start: 'top bottom', // the default values
            end: 'bottom top',
            scrub: true,
        },
    });
}

function lgParallax() {
    gsap.to('.masthead-parallax-image .img-parent', {
        yPercent: -10,
        ease: 'none',
        scrollTrigger: {
            trigger: '.masthead-parallax-image',
            start: 'top bottom', // the default values
            end: 'bottom 50%',
            scrub: true,
        },
    });
}

// Create media query
const mm = gsap.matchMedia();

function parallaxDecide() {
    // When these media queries match, the associated function will run
    mm.add('(min-width: 992px)', () => {
        lgParallax();
    });

    mm.add('(max-width: 992px)', () => {
        mobileParallax();

        return () => {
            // custom cleanup code here (runs when it STOPS matching)
            ScrollTrigger.refresh();
            lgParallax();
        };
    });
}

if ($('body').hasClass('work-detail')) {
    parallaxDecide();

    // Quoteblock turbo lines (above and below quote)
    const quoteBlocks = gsap.utils.toArray('.quote-trigger');

    quoteBlocks.forEach((item) => {
        const line = $(item).find('.turbo-line-stretch');
        gsap.to(line, {
            scaleX: 1,
            scrollTrigger: {
                trigger: item,
                start: 'top 80%',
                scrub: true,
                end: 'top 10%',
            },
        });
    });

    // Keep exploring module turbo line
    const keepExploringContainer = gsap.utils.toArray('.ke-line-trigger');

    keepExploringContainer.forEach((item) => {
        const line = $(item).find('.turbo-line-stretch');
        gsap.to(line, {
            scaleX: 1,
            scrollTrigger: {
                trigger: item,
                start: 'top 80%',
                scrub: true,
                end: 'top 10%',
            },
        });
    });

    const blocks = document.querySelectorAll('.stats-item');

    blocks.forEach((block) => {
        const num = $(block).find('.anim-number');
        const blockTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: '.animated-stats-block',
                start: 'top 85%',
                end: 'bottom top',
                toggleActions: 'play none none none',
                onEnter: () => { runNum(num); },
            },
        })
            // Animate the header items
            .from(block.querySelectorAll('.stat-hdr'), {
                duration: 1,
                opacity: 0,
                stagger: 0.25,
            });

        // Animate the content items
        const items = block.querySelectorAll('.stat-body');
        blockTimeline.from(items, {
            duration: 1,
            x: 40,
            opacity: 0,
            stagger: 0.25,
        }, 0);

        // Animate the ps in the items
        items.forEach((item, i) => {
            blockTimeline.from(item.querySelectorAll('p'), {
                duration: 1,
                opacity: 0,
                stagger: 0.25,
            }, i * 0.25);
        });
    });
}


const serviceLi = $('.service-list ul');

gsap.utils.toArray(serviceLi).forEach((elem) => {
    const listItem = $(elem).find('li');

    gsap.set(listItem, {
        paddingLeft: '40px',
        opacity: 0,
    });

    const listTl = gsap.timeline({
        paused: true,

        scrollTrigger: {
            trigger: elem,
            start: 'top 90%',
            end: 'bottom 50%',
        },
    });

    listTl.to(listItem, {
        duration: 0.3,
        ease: 'power.2',
        paddingLeft: '1.5rem',
        opacity: 1,
        stagger: 0.25,
    });

    return listTl;
});
